<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { api } from "../../service/api";
import { get, post } from "../../service/request";
import { useUserInfoStore } from "../../stores/userInfo";
import { globalStore } from "../../stores/global";
import { resetRouter } from "../../router";
import { ElMessage } from "element-plus";

const userInfo = useUserInfoStore();
const global = globalStore();
const router = useRouter();

const companyName = ref(null);
const titleBox = ref(null);

window.addEventListener("resize", () => {
  resizeTitle();
});

const resizeTitle = () => {
  let titleWidth = titleBox.value.offsetWidth;
  let boxWidth = companyName.value.offsetWidth;
  let scale = titleWidth / boxWidth;
  if (scale <= 1) {
    titleBox.value.style.transform = `scale(${scale})`;
  } else {
    titleBox.value.style.transform = `unset`;
  }
};

// 跳转链接
const goLink = (myRouterlink: string, name?: string) => {
  clearSearchValueFun();
  if (userInfo.token) {
    if (name) {
      menuActive.value = name;
    }
    router.push(myRouterlink);
  } else {
    router.replace({
      path: "/login",
      query: {
        redirect: myRouterlink,
      },
    });
  }
};

const phoneNum = computed(() => {
  if (userInfo.userName) {
    return (
      "*".repeat(userInfo.userName.length - 1) + userInfo.userName.slice(-4)
    );
  } else {
    return "";
  }
});

const clearSearchValueFun = () => {
  isShowMenu.value = false;
  global.clearSearchValue();
};

const isShowMenu = ref<boolean>(false);

// 登出
const logout = () => {
  global.clearSearchValue();
  global.setLoadingValue(true);
  post(api.logout, {}).then((res: any) => {
    global.setLoadingValue(false);
    if (res.status.code == 0) {
      userInfo.setToken("");
      userInfo.setInfo("");
      // 清除权限
      resetRouter("remove");

      router.push("/login");
    } else {
      ElMessage.error(res.status.message);
    }
  });
};

// 获取个人信息
const getuserInfo = () => {
  global.setLoadingValue(true);
  get(api.getMeInfo).then((res: any) => {
    global.setLoadingValue(false);
    if (res.status.code == 0) {
      userInfo.setInfo(res.data.user.phone || "");
    } else {
      ElMessage.error(res.status.message);
    }
  });
};

const goHome = () => {
  if (userInfo.token) {
    router.push("/home");
  }
};

const menuActive = ref<string>("");

onMounted(() => {
  if (userInfo.token) {
    getuserInfo();
  }
  resizeTitle();
  // // 监听菜单变化
  router.beforeEach((to, from, next) => {
    let newValue = to.fullPath;
    if (newValue.indexOf("/home") != -1) {
      menuActive.value = "home";
    } else if (newValue.indexOf("/policyLibrary") != -1) {
      menuActive.value = "policyLibrary";
    } else if (newValue.indexOf("/policyMatching") != -1) {
      menuActive.value = "policyMatching";
    } else if (newValue.indexOf("/dataBrain") != -1) {
      menuActive.value = "dataBrain";
    } else if (newValue.indexOf("/policyCollection") != -1) {
      menuActive.value = "policyCollection";
    } else if (newValue.indexOf("/browseRecords") != -1) {
      menuActive.value = "browseRecords";
    } else if (newValue.indexOf("/contactUs") != -1) {
      menuActive.value = "contactUs";
    } else if (newValue.indexOf("/aboutUs") != -1) {
      menuActive.value = "aboutUs";
    } else if (newValue.indexOf("/search") != -1) {
      menuActive.value = "search";
    } else if (newValue.indexOf("/policyNavigation") != -1) {
      menuActive.value = "policyNavigation";
    } else {
      menuActive.value = "";
    }
    next();
  });
});
</script>

<template>
  <div class="header-component">
    <div class="container-box">
      <div class="logo-box" :class="{ logined: userInfo.token }">
        <div class="logo laonian" @click="goHome()"></div>
        <div class="logo" @click="goHome()">EY</div>
        <div class="title-box" ref="titleBox">
          <h2 class="company-name" @click="goHome()" ref="companyName">
            政策通平台-上海市老年基金会
          </h2>
        </div>
        <i class="menu-icon" @click="isShowMenu = !isShowMenu"></i>
      </div>
      <div
        class="menu-box"
        :class="{ show: isShowMenu }"
        @click="isShowMenu = false"
      >
        <div class="menu-cont faderightIn" @click.stop>
          <div class="person-info">
            <div class="photo">
              <img src="../../assets/images/ln-avater-log.png" />
            </div>
            <div class="photo">
              <img src="../../assets/images/logo.png" />
            </div>
            <a
              v-if="!userInfo.token"
              class="login-btn"
              @click="goLink(router.currentRoute.value.path)"
              >请登录</a
            >
            <div class="username" v-else>
              <span>{{ phoneNum }}</span>
              <a @click="logout()">登出</a>
            </div>
          </div>
          <ul class="nav">
            <li :class="{ disabled: !userInfo.token }">
              <a
                @click="goLink('/home', 'home')"
                :class="{ active: menuActive == 'home'||menuActive == 'search' }"
              >
                首页
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
            <li>
              <a
                @click="goLink('/dataBrain', 'dataBrain')"
                :class="{ active: menuActive == 'dataBrain' || menuActive == 'policyNavigation' }"
                >
                政策导航
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
            <li :class="{ disabled: !userInfo.token }">
              <a
                @click="goLink('/policyMatching', 'policyMatching')"
                :class="{ active: menuActive == 'policyMatching' }"
              >
                基金会制度
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
            <li :class="{ disabled: !userInfo.token }">
              <a
                @click="goLink('/policyLibrary', 'policyLibrary')"
                :class="{ active: menuActive == 'policyLibrary' }"
              >
                风险解读
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
          </ul>
          <ul class="footer-nav">
            <li :class="{ disabled: !userInfo.token }">
              <a
                @click="goLink('/policyCollection', 'policyCollection')"
                :class="{ active: menuActive == 'policyCollection' }"
              >
                我的收藏
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
            <li class="line"></li>
            <li :class="{ disabled: !userInfo.token }">
              <a
                @click="goLink('/browseRecords', 'browseRecords')"
                :class="{ active: menuActive == 'browseRecords' }"
              >
                浏览记录
                <div class="login-tip" v-if="!userInfo.token">需登录</div>
              </a>
            </li>
            <li class="line"></li>
            <li>
              <router-link
                to="/contactUs"
                @click="clearSearchValueFun"
                :class="{ active: menuActive == 'contactUs' }"
                >联系我们</router-link
              >
            </li>
            <li class="line"></li>
            <li>
              <router-link
                to="/aboutUs"
                @click="clearSearchValueFun"
                :class="{ active: menuActive == 'aboutUs' }"
                >关于我们</router-link
              >
            </li>
          </ul>
          <i class="close-icon" @click="isShowMenu = false"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.header-component {
  width: 100%;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
  .container-box {
    height: 100%;
    display: flex;
    justify-content: space-between;
    .logo-box {
      padding: 14px 0;
      display: flex;
      justify-content: start;
      align-items: center;
      width: 45%;
      &.logined {
        .logo,
        .company-name {
          cursor: pointer;
        }
      }
      .logo {
        width: 59px;
        height: 59px;
        background: url("@/assets/images/logo.png") no-repeat center center;
        background-size: 100%;
        font-size: 0;
        margin-right: 20px;
        &.laonian{
          background: url("@/assets/images/ln-logo.png") no-repeat center center;
          background-size: contain;
          margin-right: 18px;
        }
      }
      .title-box {
        flex: 1;
        width: 0;
        display: flex;
        justify-content: flex-start;
      }
      .company-name {
        font-size: 34px;
        word-break: normal;
        white-space: nowrap;
        width: max-content;
        letter-spacing: 1px;
        span {
          font-size: 22px;
          margin-left: 10px;
          font-weight: 500;
          font-family: "SourceHanSansCN-Medium";
        }
      }
      .menu-icon {
        display: none;
      }
    }
    .menu-box {
      padding: 27px 0;
      width: 55%;
      display: flex;
      align-items: center;
      .menu-cont {
        width: 100%;
        padding-right: 210px;
        position: relative;
      }
      .nav {
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 544px;
        li {
          a {
            font-size: 18px;
            margin: 10px 20px;
            cursor: pointer;
            position: relative;
            display: block;
            position: relative;
            line-height: 36px;
            &:hover {
              .login-tip {
                display: block;
              }
            }
            .login-tip {
              display: none;
              font-size: 12px;
              padding: 3px;
              border-radius: 3px;
              background-color: #eeeeee;
              position: absolute;
              right: -25px;
              top: -8px;
              &:after {
                content: "";
                width: 6px;
                height: 5px;
                background: url("@/assets/images/login_tip_pointer.png")
                  no-repeat center center;
                position: absolute;
                left: 0;
                bottom: -5px;
              }
            }
          }
          .active {
            font-weight: bolder;
            border-bottom: 4px solid #ffe600;
            
          }
          &.disabled a {
            color: #999999;
          }
        }
      }
      .footer-nav {
        display: none;
      }
      .person-info {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -17.5px;
        .photo {
          width: 35px;
          height: 35px;
          border: 1px solid #dddddd;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;
          img {
            width: 70%;
            margin-left: 15%;
            margin-top: 15%;
          }
        }
        .login-btn {
          font-size: 16px;
          color: #666666;
          cursor: pointer;
          display: inline-block;
          vertical-align: middle;
          padding-right: 20px;
        }
        .username {
          display: inline-block;
          vertical-align: middle;
          span {
            font-size: 16px;
            padding-right: 8px;
            margin-right: 8px;
            border-right: 1px solid #e5e5e5;
          }
          a {
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
      .close-icon {
        display: none;
      }
    }
  }
}

@media (max-width: 768px) {
  .header-component {
    height: 70px;
    .container-box {
      display: block;
      .logo-box {
        padding: 13px 0 12px 0;
        width: 100%;
        position: relative;
        .logo {
          width: 55px;
          height: 45px;
          margin-right: 15px;
        }
        .company-name {
          font-size: 20px;
          span {
            font-size: 12px;
            margin-left: 0;
            display: block;
          }
        }
        .menu-icon {
          width: 30px;
          height: 30px;
          display: block;
          position: absolute;
          top: 50%;
          margin-top: -15px;
          right: 0;
          background: url("@/assets/images/menu.png") no-repeat center center;
          background-size: cover;
          cursor: pointer;
        }
      }
      .menu-box {
        width: 100%;
        position: fixed;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        z-index: 9;
        top: 0;
        left: 0;
        padding: 0;
        display: none;
        &.show {
          display: block;
        }
        .menu-cont {
          width: 80%;
          height: 100%;
          background: #ffffff;
          padding: 25px 25px 20px 25px;
          display: block;
          position: relative;
          .nav {
            display: block;
            border-top: 1px solid rgba(60, 60, 60, 0.12);
            padding: 10px 0 0 0;
            li {
              padding: 10px 0;
              a {
                font-size: 18px;
                padding: 0;
                .login-tip {
                  display: none;
                }
              }
              .active {
                &::after {
                  display: none;
                }
              }
            }
          }
          .footer-nav {
            display: block;
            padding: 0;
            margin: 0;
            li {
              padding: 10px 0;
              &.line {
                display: none;
              }
              a {
                font-size: 18px;
                display: block;
                .login-tip {
                  display: none;
                }
              }
              .active {
                color: #ffe600;
                &::after {
                  display: none;
                }
              }
              &.disabled a {
                color: #999999;
              }
            }
          }
          .person-info {
            width: 100%;
            position: unset;
            margin: 0;
            padding-bottom: 15px;
          }
          .close-icon {
            width: 25px;
            height: 25px;
            display: block;
            position: absolute;
            top: 20px;
            right: 20px;
            background: url("@/assets/images/close.png") no-repeat center center;
            background-size: cover;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
